import React from 'react';
import PolicyPage from './PolicyPage';

// Content from Admin → policies (falls back to the recommended text until saved).
function CancelPolicy() {
  return <PolicyPage policyKey="canclePolicy" icon="fa-undo" />;
}

export default CancelPolicy;
